<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10SLeMb/tc-custom/9780310563280.jpg?1709150512263" alt="This image is the cover for the book Naked Gospel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Naked Gospel
      </h1>
      <p class="bookDescription body article font2">
        <p><b>For those who are weary of Christian cliché and compromise crowding out what was supposed to be good news, <i>The Naked Gospel </i>offers the fresh take on the story of Jesus you've been waiting for.</b></p><p>As a university student, Andrew Farley found himself physically and emotionally addicted to street evangelism and Bible study. Yet despite his fervid behavior, he knew something was missing.</p><p>That something was an understanding of the gospel that is stripped of the churchy jargon and hypocrisies of the modern church. <i>The Naked Gospel</i> finds kindred spirits among those who are burned out on experience-chasing, ceremonialism, or legalism. It dismantles churchy jargon and powerless ideas and puts forth a message that is simple but life changing:</p><p>Jesus plus nothing. 100% natural. No additives.</p><p><i>The Naked Gospel</i> is an invitation to dive deep into the indispensable, powerful core of the Christian faith. Are you ready?</p><p>Spanish edition also available.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Farley
      </h2>
      
      <p class="authorDescription body article">Dr. Andrew Farley is senior pastor of Ecclesia, an evangelical Bible church that has resided on the high plains of west Texas for more than fifty years. Andrew is a bestselling author of several Christian books and a frequent speaker at churches and Christian campus events. Andrew is also a tenured professor of linguistics at Texas Tech University and lives in Lubbock, Texas with his wife, Katharine, and their son Gavin. For more information, please visit AndrewFarley.org.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?88ac0fa6